import { useState } from "react";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "What services do you offer?",
    answer:
      "We offer a wide range of services including web development, mobile apps, digital marketing, and design solutions tailored to your needs.",
  },
  {
    question: "How do I get started?",
    answer:
      "You can get started by reaching out to us through the contact form. We’ll schedule a quick discovery call to understand your goals.",
  },
  {
    question: "Do you offer ongoing support and maintenance?",
    answer:
      "Yes, we provide post-launch support and maintenance to ensure your application remains up-to-date and secure.",
  },
  {
    question: "Will my website be mobile-friendly?",
    answer:
      "Absolutely! All our websites are fully responsive and optimized for a seamless experience across all devices.",
  },
];

const FAQSection = ({ screenInfo }) => {
  const [activeFAQ, setActiveFAQ] = useState(null);
  const { isDesktopModeOnMobile, width } = screenInfo;

  const handleCardClick = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  return (
    <div
      className={`${
        isDesktopModeOnMobile && width > 768
          ? ""
          : "lg:min-h-screen  "
      }  w-full  flex  justify-center 2xl:items-center lg:pt-[8rem] pt-[6rem] sm:py-[8rem]   px-4 sm:px-6 md:px-6 max-sm:pb-0 pb-10 lg:pb-[4.5rem]  `}
    >
      <div className="flex flex-col gap-6 sm:gap-8 text-white w-full max-w-screen-md md:max-w-[90vw] lg:max-w-[80vw] xl:max-w-[80vw] 2xl:max-w-[70vw]">
        {/* Title */}
        <div className="flex flex-col gap-2 sm:gap-4 items-center text-center">
          <h1 className="poppins-semibold text-2xl sm:text-3xl md:text-4xl">
            Frequently Asked Questions
          </h1>
          <p className="mt-2 text-sm text-gray-400">
            Find answers to common queries about our services.
          </p>
        </div>

        {/* FAQ Cards */}
        <div className="flex flex-wrap justify-center gap-10">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              onClick={() => handleCardClick(index)}
              className="relative w-[300px] h-[150px] sm:h-[200px] cursor-pointer"
              style={{ perspective: 1000 }}
              whileHover={{ scale: 1.05 }}
            >
              <motion.div
                className="relative w-full h-full shadow-2xl rounded-xl"
                style={{
                  transformStyle: "preserve-3d",
                }}
                animate={{
                  rotateY: activeFAQ === index ? 180 : 0,
                }}
                initial={{ rotateY: 0 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
              >
                {/* Front */}
                <motion.div
                  className="absolute inset-0 flex items-center justify-center bg-[#6935f8] bg-opacity-20 backdrop-blur-md  border border-white/20 rounded-xl p-4 text-center text-white"
                  style={{
                    backfaceVisibility: "hidden",
                    transform: "rotateY(0deg)",
                  }}
                >
                  <span className="poppins-regular leading-[18px] tracking-wide text-sm sm:text-base">{faq.question}</span>
                </motion.div>

                {/* Back */}
                <motion.div
                  className="absolute inset-0 flex items-center justify-center bg-white/20 backdrop-blur-lg border border-white/30 rounded-xl p-4 text-center text-white"
                  style={{
                    backfaceVisibility: "hidden",
                    transform: "rotateY(180deg)",
                  }}
                >
                  <span className="poppins-regular leading-[18px] tracking-wide text-sm sm:text-sm">{faq.answer}</span>
                </motion.div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
